<div class="row">
  <div class="col-md-12 boton-borrar">
    <button [ngClass]="{'hidden-xs': display_list}" *ngIf="!!selected_items.length" (click)="onRemoveAll.emit()">{{language.BORRAR_FILTROS_TITLE}}</button>
  </div>
</div>
<div class="filters-bar-container">
  <div class="row">
    <div *ngIf="!!selected_items.length" class="col-sm-8 selected-filters"
      [ngClass]="{'col-xs-8': !display_list && selected_items.length, 'col-xs-1': display_list || !selected_items.length}">
      <label #selector class="select-area" (keydown)="key($event)">
        <div class="item-box">
          <div class="item" *ngFor="let item of selected_items ;let i = index; trackBy: trackItem">
            <div class="delete-filter" (click)="delete(item)">
              <i class="material-icons" style="font-size:16px;">clear</i>
              <!-- <img src="https://www.flaticon.es/svg/static/icons/svg/2919/2919543.svg" alt=""> -->
            </div>
            <span>{{item.text}}</span>
          </div>
          <!-- <input
            type="text"
            name="filter"
            [(ngModel)]="filter"
            [placeholder]="language.FILTERS_BAR_PLACEHOLDER"
            #input
            (focus)="display_list = true"
            (focusout)="close()"> -->
        </div>

      </label>
    </div>
    <div *ngIf="!!selected_items.length" class="col-sm-2 hidden-xs results-number" [ngClass]="{'no-count': resultsCount === 0 || display_list}">{{resultsCount}}
      {{language.RESULTS_CONTER_TITLE}}</div>
    <div (submit)="submitBloque()" class=" search-input" (keydown)="key($event)"
      [ngClass]="{
        'col-xs-4': !display_list && selected_items.length,
        'col-xs-12': display_list || !selected_items.length,
        'col-sm-4': display_list,
        'col-sm-2': !display_list}">
        <i class="material-icons" style="font-size:22px;">search</i>
      <!-- <i><img src="assets/img-svg/lupa.png" alt="" srcset=""></i> -->
      <!-- <input
      (focus)="searchFocus = true"
      (focusout)="searchFocus = false"
      type="text"
      required
      id="filter-bloque"
      [(ngModel)]="bloqueFilter"
      name="search_keyword"
      [placeholder]="language.FILTERS_BAR_KEYWORD_PLACEHOLDER"> -->
      <input type="text" name="filter" [(ngModel)]="filter" autocomplete="off"
        [placeholder]="language.FILTERS_BAR_KEYWORD_PLACEHOLDER" #input (focus)="display_list = true"
        (focusout)="close(true)" (blur)="close(true)">

        <div class="auto-complete">

          <div class="list" [hidden]="!display_list">
            <ul #list (mouseover)="list_hovered = true" (mouseleave)="list_hovered = false">
              <li [ngClass]="{'hover': ishover(i)}"
                *ngFor="let option of options_array();let i = index;let last = last; trackBy: trackItem"
                (mousedown)="select(option, i)" (mouseover)="hover = i">
                <span class="name">{{option.text}}</span>
              </li>
            </ul>
          </div>
        </div>
    </div>

  </div>
</div>
<br>
